import { render, staticRenderFns } from "./BrandsView.vue?vue&type=template&id=a74d9822&"
import script from "./BrandsView.vue?vue&type=script&lang=js&"
export * from "./BrandsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports